// created for the CMS

import { AuthContext } from './authContext';
import { useContext } from 'react';
import { BackendUser as User } from '@/infrastructure/clients/BackendClient';
import { useServices } from '@/infrastructure/providers/ServiceProvider';

interface UseAuthResult {
  user: User | null;
  loading: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signUp: (email: string, password: string, fullName?: string) => Promise<void>;
  signOut: () => Promise<void>;
  refreshUser: () => Promise<void>;
}

export const useAuth = (): UseAuthResult => {
  const { user, loading, refreshUser } = useContext(AuthContext);
  const services = useServices();

  const signIn = async (email: string, password: string): Promise<void> => {
    const response = await services.supabase.auth.signInWithPassword({
      email,
      password
    });

    if (response.error) {
      throw new Error(response.error.message);
    }
  };

  const signUp = async (): Promise<void> => {
    // Signup goes through the backend AuthService (services.auth.signUp)
    // This hook is for CMS — redirect to the signup page instead
    throw new Error('Please use the signup page to create an account.');
  };

  const signOut = async (): Promise<void> => {
    const { error } = await services.supabase.auth.signOut();
    if (error) {
      throw new Error(error.message);
    }
  };

  return { 
    user, 
    loading, 
    signIn, 
    signUp, 
    signOut,
    refreshUser
  };
}; 